
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class TestGroupTestDialog extends SiteEntityDialog<TestGroupTestRow, any> {
        protected getFormKey() { return TestGroupTestForm.formKey; }
        protected getIdProperty() { return TestGroupTestRow.idProperty; }
        protected getLocalTextPrefix() { return TestGroupTestRow.localTextPrefix; }
        protected getNameProperty() { return TestGroupTestRow.nameProperty; }
        protected getService() { return TestGroupTestService.baseUrl; }

        protected form = new TestGroupTestForm(this.idPrefix);

    }
}